import React, { memo } from "react";

import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  VStack,
} from "@chakra-ui/react";

import { PinOutlineIcon } from "modules/icons";
import { MAX_PINNED_MESSAGE_THREADS } from "modules/utils/Constants";
import { useOverlay } from "modules/providers/overlay-provider";

const PinnedMessageThreadsLimitModal = () => {
  const { closeModal } = useOverlay();

  return (
    <Modal isOpen onClose={closeModal} isCentered>
      <ModalOverlay />
      <ModalContent borderRadius={16}>
        <ModalBody p={6}>
          <VStack spacing={4}>
            <PinOutlineIcon boxSize={16} />
            <Text fontSize={24} fontWeight={600} fontFamily="Outfit">
              Pinned Chats & Threads
            </Text>
            <Text textAlign="center" fontSize="sm">
              You have reached the maximum of {MAX_PINNED_MESSAGE_THREADS} pins.
              <br />
              Unpin an existing chat/thread to add this one.
            </Text>
            <HStack>
              <Button
                height={50}
                w={139}
                onClick={closeModal}
                fontWeight={700}
                fontSize={16}
              >
                Got it!
              </Button>
            </HStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default memo(PinnedMessageThreadsLimitModal);
